var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"nav"},[_c('Navgation')],1),_c('div',{staticClass:"content"},[_c('Main')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }